// رأس تقرير الحضور وبطاقاته — بنفس هوية تقرير الرواتب.
import { esc, today } from "../payroll/reportFormat";
import { brandLogo, brandName } from "../payroll/reportBrand";
import { sealQr } from "../payroll/sealQr";
import { printButton } from "../reports/reportButtons";

const card = (label, value, tone = "") =>
  `<div class="card"><div class="label">${esc(label)}</div><div class="value ${tone}">${esc(value)}</div></div>`;

export const header = (data, L, { custom, brand } = {}) => {
  const one = data.employees.length === 1;
  const title = custom ? L.titleCustom : one ? L.titleOne : L.titleMany;
  const subtitle = one ? data.employees[0].employee_name : data.branch_name || L.allBranches;
  const range = `${data.period_start} ${L.periodTo} ${data.period_end}`;
  const perBranch = (data.branch_periods || []).length > 1
    ? `<p>${data.branch_periods
        .map((b) => `${esc(b.branch_name)}: ${b.period_start} → ${b.period_end}` +
          (b.payroll_day ? ` (${esc(L.payDay)} ${b.payroll_day})` : ""))
        .join(" · ")}</p>`
    : "";
  return `<div class="header">
    ${brandLogo(brand)}
    ${brandName(brand)}
    ${data.sealed ? `<div class="seal">${esc(L.sealedBadge)} · ${esc(String(data.sealed_at || "").slice(0, 10))}</div>` : ""}
    <h1>${esc(title)}</h1>
    <h2>${esc(subtitle)}</h2>
    <p class="period">${esc(L.period)}: ${esc(range)} (${data.period_days} ${esc(L.days)})</p>
    ${perBranch}
    ${one ? `<p>${esc(data.employees[0].branch_name)}</p>` : ""}
    <p>${esc(L.generatedAt)}: ${today()}</p>
    ${sealQr(data, L)}
  </div>`;
};

export const cards = (data, L) => {
  const t = data.totals;
  return `<div class="cards">${[
    card(L.cards[0], t.employees),
    card(L.cards[1], t.days_worked),
    card(L.cards[2], t.absence_days, t.absence_days > 0 ? "negative" : "positive"),
    card(L.cards[3], t.late_count, t.late_count > 0 ? "negative" : "positive"),
  ].join("")}</div>`;
};

export const buttons = (L, share = null, pdfUrl = null) =>
  `<div class="pdf-bar">
    ${printButton(L)}
    ${pdfUrl ? `<button class="btn-pdfshare" data-testid="report-share-pdf" onclick="shareReportPdf()">${esc(L.sharePdf)}</button>` : ""}
    ${share?.url ? `<button class="btn-copy" data-testid="report-copy-top" onclick="copyReportLink('${esc(share.short || share.url)}')">${esc(L.copyLink)}</button>` : ""}
    <button class="btn-close" data-testid="report-close" onclick="reportClose()">${esc(L.close)}</button>
  </div>`;
